import React, { useState } from 'react'
import { Breadcrumb, Button, Card, Row, Col } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamation, faHome } from '@fortawesome/free-solid-svg-icons';
import { Form, Input, Modal, Button as AntButton, Table, Space, Tag, Upload, Select, Empty } from 'antd';
import { InboxOutlined } from '@ant-design/icons'
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { Editor } from "react-draft-wysiwyg";
// import { EditorState } from "draft-js";
import { createHomeFeature, updateFeature } from '../../../services/apiCalls';
import AlertToast from '../../../components/AlertToast';
import { featureAlert, featureResponse, features, homePage, homeRefresh } from '../../../states/home';
import { dummyRequest, getHtml } from '../../../services/utilities';
import { imageUrl } from '../../../services/axios';
import HomeCard from './HomeCard';
import MediaCard from './MediaCard';

const Home = () => {
  // const data = useRecoilValueLoadable(features)
  const data = useRecoilValue(homePage)
  const [viewModal, setViewModal] = useState(false)
  const [editModal, setEditModal] = useState(false)
  const [loading, setLoading] = useState(false)
  const [value, setValue] = useState({})
  const [file, setFile] = useState("")
  const [showAlert, setShowAlert] = useRecoilState(featureAlert);
  const [response, setResponse] = useRecoilState(featureResponse)
  const [uploadIm, setUploadImage] = useState(false)
  const [editor, setEditor] = useState("")
  const [editorDesc, setEditorDesc] = useState("")
  const setRefresh = useSetRecoilState(homeRefresh)
  const [form] = Form.useForm()
  const { confirm } = Modal;
  const homeCall = data?.data && data?.data
  const { home, homePOS, homeProduct, homeProductList, connect } = homeCall ? homeCall : []
  const featureList = data?.homeFeatures
  const explore = featureList && featureList.filter(f => f.type == "explore")
  const feature = featureList && featureList.filter(f => f.type == "home")
  const amazing = featureList && featureList.filter(f => f.type == "amazing")
  const unique = featureList && featureList.filter(f => f.type == "unique")
  const { Option } = Select;
  const onEditorStateChange = editorState => {
    setEditor(editorState);
  };
  const onEditorStateChanges = editorState => {
    setEditorDesc(editorState);
  };
  const columns = [
    {
      title: '#',
      dataIndex: 'id',
      key: 'id',
    },
    {
      title: 'Image',
      dataIndex: 'image_url',
      key: 'image_url',
      render: text => <img alt="features" src={`${imageUrl}${text}`} />
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Status',
      dataIndex: 'visible',
      key: 'visible',
      render: text => <Tag color={text ? "#2db7f5" : "#f50"}>{text ? "Show" : "Hide"}</Tag>
    },
    {
      title: 'Action',
      dataIndex: 'id',
      key: 'id',
      render: (id, record) => {
        const action = record.visible ? "Hide" : "Show"
        return (
          <Space size="middle">
            <AntButton type="ghost" onClick={() => handleUpdateModal(record)}>Edit </AntButton>
            <AntButton type="danger" onClick={() => confirmAction(id, action)}>{action}</AntButton>
          </Space>
        )
      },
    },
  ];

  const confirmAction = (id, action) => {
    confirm({
      title: `Are you sure you want to ${action} this Contact?`,
      icon: <FontAwesomeIcon icon={faExclamation} color="primary" />,
      content: 'Click Ok to continue',
      onOk() {
        handleShowHide(id, action.toLowerCase())
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  const handleShowHide = async (id, type) => {
    const date = new Date()
    const res = await updateFeature({ data: {}, type, id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
  }

  const onFinish = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    fd.append('title', getHtml(editor))
    fd.append('description', getHtml(editorDesc))
    // fd.append('title', val.title)
    // fd.append('description', val.description)
    fd.append('type', val.type)
    // fd.append('link_url', val.link_url)
    fd.append('google_url', val.google_url)
    fd.append('position', val.position)
    fd.append('app_store_url', val.app_store_url)
    fd.append('get_start_url', val.get_start_url)
    fd.append('file', file);
    const res = await createHomeFeature(fd)
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setViewModal(false)
      form.resetFields()
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
      form.resetFields()
    }
    setLoading(false)
    form.resetFields()
  }

  const onFinishUpdate = async (val) => {
    setLoading(true)
    const date = new Date()
    const fd = new FormData();
    fd.append('title', val.title)
    fd.append('description', val.description)
    fd.append('type', val.type)
    fd.append('id', val.id)
    fd.append('image_url', val.image_url)
    fd.append('feature_image', file);
    const res = await updateFeature({ data: fd, type: "update", id: val.id })
    if (res.status) {
      setResponse({ message: res.message, title: "success" })
      setShowAlert(true)
      setRefresh(date.toTimeString())
      setEditModal(false)
    } else {
      setResponse({ message: res.message || res, title: "failed" })
      setShowAlert(true)
    }
    setLoading(false)
  }

  const handleUpdateModal = (val) => {
    setEditModal(true)
    setValue(val)
  }

  const getBase64 = (img, callback) => {
    const reader = new FileReader();
    reader.addEventListener('load', () => callback(reader.result));
    reader.readAsDataURL(img);
  }

  const handleChange = info => {
    if (info.file.status === 'done') {
      // Get this url from response in real world.
      getBase64(info.file.originFileObj, imageUrl => {
        setFile(info.file.originFileObj)
      });
    }
  };
  console.log(uploadIm)
  return (
    <div>
      <AlertToast showAlert={showAlert} setShowAlert={setShowAlert} response={response} page="Home" />
      <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center py-4">
        <div className="d-block mb-4 mb-md-0">
          <Breadcrumb className="d-none d-md-inline-block" listProps={{ className: "breadcrumb-dark breadcrumb-transparent" }}>
            <Breadcrumb.Item><FontAwesomeIcon icon={faHome} /></Breadcrumb.Item>
            <Breadcrumb.Item>Waya pay</Breadcrumb.Item>
            <Breadcrumb.Item active>Home</Breadcrumb.Item>
          </Breadcrumb>
          <h4>Home Page</h4>
        </div>
        <div className="table-settings mb-4">
          <Button variant="success" className="text-white me-3" onClick={() => setViewModal(true)}>
            Create New Feature <FontAwesomeIcon icon={faHome} className="d-none d-sm-inline ms-1" />
          </Button>
        </div>
      </div>
      {home && home?.length === 0 ? <Empty />:
      home && home?.map(dat =>
        <HomeCard key={dat.id} featureImg={true} img={dat.image_url} description={dat.description} title={dat.title} 
          type="home" id={dat.id} link={true} status={dat.status} url="/admin/home_page/hero" name='Home Feature' />
      )}
      <Row>
        <h4>Product & Services</h4>
        {homeProduct && homeProduct?.length === 0 ? <Empty />:
        homeProduct && homeProduct?.map(ex =>
          <HomeCard key={ex.id} featureImg={false} img={ex.image_url} description={ex.description} title={ex.title} 
            type="product" id={ex.id} status={ex.status} link={false} link_url={ex.link_url} name='Product & Services' />
        )}
      </Row>
      <Row>
        <h4>Product List</h4>
        {homeProductList && homeProductList?.length === 0 ? <Empty />:
        homeProductList && homeProductList?.map(ex =>
          <Col xs={12} xl={4} lg={4} key={ex.id}>
            <HomeCard key={ex.id} featureImg={true} img={ex.image_url} description={ex.description} title={ex.title} 
            type="productlist" id={ex.id} status={ex.status} link={true} link_url={ex.link_url} name='Product List' />
          </Col>
        )}
      </Row>
      <Row>
        <h4>Sales Point</h4>
        {homePOS && homePOS?.length === 0 ? <Empty />:
        homePOS && homePOS?.map(ex =>
          <Col xs={12} xl={12} lg={12} key={ex.id}>
            <HomeCard key={ex.id} featureImg={true} img={ex.image_url} description={ex.description} title={ex.title} 
              type="home" id={ex.id} parentId={ex.id} status={ex.status} link={true} link_url={ex.link_url} list={ex.data} name='Sales Point' 
            />
          </Col>
        )}
      </Row>
      <Row>
        <h4>Connect with us</h4>
        {connect && connect?.length === 0 ? <Empty />:
        connect && connect?.map(ex =>
          <Col xs={12} xl={12} lg={12} key={ex.id}>
            <HomeCard key={ex.id} featureImg={true} color='#f60' img={ex.image_url} description={ex.description} title={ex.title} 
              type="home" id={ex.id} types={ex.type} parentId={ex.id} status={ex.status} link={true} link_url={ex.link_url} list={ex.data} name='Sales Point' 
            />
          </Col>
        )}
      </Row>

      {/* <Card border="light" className="bg-white shadow-sm mb-4">
        <Card.Body>
          <h5 className="mb-4 text-primary">Unique Feature List</h5>
          <Table columns={columns} loading={loading} pagination={false} dataSource={unique} rowKey="id" />
        </Card.Body>
      </Card> */}
      {/* <MediaCard img1={home.feature_image_url} img={home.download_app_image_url} video_url={home.feature_video_url} url="/admin/home_page/others" /> */}

      {/*create feature start */}
      <Modal
        title="Create New Feature"
        centered
        visible={viewModal}
        footer={null}
        onCancel={() => setViewModal(false)}
      >
        <Form form={form} onFinish={onFinish} layout="vertical">
          <Form.Item label="Type" name="type" rules={[{ required: true }]}>
            <Select onChange={(v) => { if (v === "connect") { setUploadImage(true) } else { setUploadImage(false) } }}>
              <Option key='1' value="home">Home Feature</Option>
              <Option key='2' value="product">Product & Services</Option>
              <Option key='3' value="productlist">Product List</Option>
              <Option key='4' value="POS">Sales Point</Option>
              <Option key='5' value="other">Others</Option>
              {connect?.length === 0 &&
                <Option key='6' value="connect">Connect with us</Option>
              }
              {/* <Option value="t-pos">Terminal Pos</Option>
              <Option value="amazing">Amazing Feature</Option> */}
            </Select>
          </Form.Item>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 50,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          <Form.Item label="Description" name="description" rules={[{ required: true }]}>
            {/* <Input.TextArea /> */}
            <Editor
              editorState={editorDesc}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 100,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChanges}
            />
          </Form.Item>
          {/* <Form.Item label="Button URL" name="link_url">
            <Input />
          </Form.Item> */}
          <Form.Item label="Position" name="position">
            <Input type='number' />
          </Form.Item>
          {/* } */}
          {/* {uploadIm && */}
          {!uploadIm &&
            <Form.Item label="Google Play Link" name="google_url">
              <Input />
            </Form.Item>
          }
          <Form.Item label={uploadIm ? "And Brochure Link":"App Store Link"} name="app_url">
            <Input />
          </Form.Item>
          <Form.Item label="Get Started Link" name="get_start_url">
            <Input />
          </Form.Item>
          {/* {uploadImage && */}
            <Form.Item >
              <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
                <AntButton icon={<InboxOutlined />}>{uploadIm ? 'Upload Brochure': 'Upload Feature Image'}</AntButton>
              </Upload>
            </Form.Item>
            {/* } */}
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Create
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/*create feature end */}

      {/* update feature start */}
      <Modal
        title="Update Feature"
        centered
        visible={editModal}
        footer={null}
        onCancel={() => setEditModal(false)}
      >
        <Form form={form} onFinish={onFinishUpdate} layout="vertical" initialValues={{ title: value.title, description: value.description, id: value.id, image_url: value.image_url, type: value.type }}>
          <Form.Item label="Title" name="title" rules={[{ required: true }]}>
            {/* <Input /> */}
            <Editor
              editorState={editor}
              editorClassName="px-3 border border-gray-1"
              editorStyle={{
                height: 200,
                overflow: 'auto',
              }}
              onEditorStateChange={onEditorStateChange}
            />
          </Form.Item>
          <Form.Item label="Description" name="description" rules={[{ required: true }]}>
            <Input.TextArea />
          </Form.Item>
          <Form.Item label="Type" name="type" rules={[{ required: true }]}>
            <Select onChange={(v) => { if (v == "home") { setUploadImage(false) } else { setUploadImage(true) } }}>
              <Option value="explore">Explore Feature</Option>
              <Option value="unique">Unique Feature</Option>
              <Option value="home">Home Feature</Option>
              <Option value="w-pos">Web Pos</Option>
              <Option value="t-pos">Terminal Pos</Option>
              <Option value="amazing">Amazing Feature</Option>
              <Option value="amazing">Others</Option>
            </Select>
          </Form.Item>
          <Form.Item label="Position" name="position" rules={[{ required: true }]}>
            <Input />
          </Form.Item>
          <Form.Item name="id" hidden>
            <Input />
          </Form.Item>
          {/* {uploadImage && */}
          <Form.Item >
            <Upload onChange={handleChange} customRequest={dummyRequest} maxCount={1}>
              <AntButton icon={<InboxOutlined />}>Upload Feature Image</AntButton>
            </Upload>
          </Form.Item>
            {/* } */}
          <Form.Item>
            <AntButton type="primary" htmlType="submit" loading={loading}>
              Update
            </AntButton>
          </Form.Item>
        </Form>
      </Modal>
      {/* update feature end */}
    </div>
  )
}

export default Home
